export enum OUR_PARTNERS_TABS {
    GAME_DEVELOPERS = "gameDevelopers",
    INVESTMENTS = "investments",
    INFLUENCERS = "influencers",
    WINZO_STORE = "winzoStore"

}

export enum OUR_INVESTORS_TYPE {
    ABOUT_US = 2,
}

export enum PAGE_TYPE {
    GDC = 1,
    GCOE = 2,
}

export enum CTA_TYPES {
    REDIRECT = "redirect",
    MODAL = "modal"
}